.headerButtonContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  height: 34px;
  width: 34px;
  border-radius: 100%;
  transition: background-color 0.25s ease, color 0.25s ease;
  position: relative;
  
  @include themify($themes) {
    color: themed("main-primary");
    background-color: themed("neutral-tertiary");

    &:not(.active) {
      &:hover {
        background-color: themed("neutral-secondary");
        @include dark-mode {
          &:hover {
            background-color: themed("neutral-primary");
          }
        }
      }
    }

    &.active {
      background-color: themed("brand-primary");
    }
  }
  


  svg {
    user-select: none;
    pointer-events: none;
    height: 14px;
    width: auto;
    color: inherit;
  }
}
